import { ProjectDetailsContextProvider } from "./contexts/project-details-context";
import { ProjectDetails as ProjectDetailsInternal } from "./project-details";

const ProjectDetails = () => (
  <ProjectDetailsContextProvider>
    <ProjectDetailsInternal />
  </ProjectDetailsContextProvider>
);

export { ProjectDetails };
